export default "__VITE_ASSET__C$nq4SZf__"